import { Carousel } from "antd";
const Slide = ({ sliderArray }) => {
  return (
    <>
      <Carousel className="mb-2" autoplay={{ dotDuration: true }} autoplaySpeed={2000}>
        {sliderArray?.map((item, i) => (
          <div className="flex items-center gap-4 flex-grow">
            <div key={i} className="flex items-center gap-2">
              <div className="w-[90%] flex gap-4 items-center">
                <div className="w-[45px] h-[45px] bg-[#A334341A] flex justify-center items-center rounded-xl">
                  {typeof item.icon === "string" ? (
                    <img src={item.icon} alt="card-logo" />
                  ) : (
                    item.icon
                  )}
                </div>
                <p className="text-xl text-left break-words whitespace-normal">{item.title}</p>
              </div>
              <div className="text-right text-3xl font-semibold">{item.count}</div>
            </div>
          </div>
        ))}
      </Carousel>
    </>
  );
};

export default Slide;
